import {Garage, Image, Service} from "@App/types";
import {ServiceShouldDisplayReviews} from "@App/utils/conditionals/services";

/**
 * Checks if a garage is bookable
 *
 * @param Garage
 * @constructor
 */
export const GarageIsBookable = (garage: Garage): boolean => garage?.pivot.bookable

export const GarageHasAvailableDays = (garage: Garage): boolean => garage?.available_days?.length > 0

export const GarageHasNationwideService = (garage: Garage): boolean => garage?.nationwide_service

export const GarageIsDrivinLicenseCheckpoint = (garage: Garage): boolean => garage?.drivingLicenseCheckpoint?.name.length > 0

export const GarageHasPhone = (garage: Garage): boolean => garage?.phone?.length > 0

export const GarageHasLessImages = (images: Image[]): boolean => images?.length < 4
export const GarageHasOneImage = (images: Image[]): boolean => images?.length === 1

export const GarageHasBillingGroups = (garage: Garage): boolean => garage?.billingGroups.length > 0

export const GarageShouldDisplayMapmarkerNoRating = (garage: Garage, service: Service) => {
    return (!garage?.rating || (garage?.rating && !ServiceShouldDisplayReviews(service)) || !GarageIsBookable(garage))
}

export const GarageShouldDisplayMapmarkerWithRating = (garage: Garage, service: Service) => {
    return (garage?.rating && ServiceShouldDisplayReviews(service) && GarageIsBookable(garage))
}
